// src/components/EmptyState.js
import React from 'react';
import { DocumentMagnifyingGlassIcon } from '@heroicons/react/24/outline';

const EmptyState = ({ filters }) => {
  const hasFilters = filters.type !== 'all' || filters.status !== 'all' || filters.search;
  
  return (
    <div className="text-center py-16">
      <DocumentMagnifyingGlassIcon className="mx-auto h-16 w-16 text-gray-400" />
      <h3 className="mt-4 text-lg font-medium text-gray-900">
        {hasFilters ? "No se encontraron requerimientos" : "Bandeja vacía"}
      </h3>
      <p className="mt-1 text-sm text-gray-500">
        {hasFilters
          ? "Intenta ajustar tus filtros de búsqueda."
          : "No hay requerimientos asignados a tu rol actualmente."}
      </p>
      {hasFilters && (
        <button
          onClick={() => window.location.reload()}
          className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none"
        >
          Limpiar filtros
        </button>
      )}
    </div>
  );
};

export default EmptyState;